import { render } from "./FlightPassengers.vue?vue&type=template&id=3432b3cd"
import script from "./FlightPassengers.vue?vue&type=script&lang=js"
export * from "./FlightPassengers.vue?vue&type=script&lang=js"

import "./FlightPassengers.vue?vue&type=style&index=0&id=3432b3cd&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__